// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--2Aw5e";
export var textSide = "styles-module--textSide--1ZX1u";
export var content = "styles-module--content--2I9C-";
export var grayQuotes = "styles-module--grayQuotes--3AVkV";
export var imageSide = "styles-module--imageSide--304Rb";
export var logoWrapper = "styles-module--logoWrapper--23QN9";
export var imageCol = "styles-module--imageCol--1HYBS";
export var leftPart = "styles-module--leftPart--146vV";
export var rightPart = "styles-module--rightPart--3cral";